import request from '@/utils/requestV2'
const qs = require('qs')

/**
 * 电表读数记录列表
 * @param {Object} data
 * @returns
 */
export function pageElectricMeterRecord (data) {
  return request.post('/ooh-invest/electricMeterRecord/pageElectricMeterRecord', qs.stringify(data))
}
/**
 * 电表合同列表
 * @param {Object} data
 * @returns
 */
export function pgeElectricMetricContract (data) {
  return request.post('/ooh-invest/electricMeterRecord/pgeElectricMetricContract', qs.stringify(data))
}
/**
 * 当线损修改后，需要同步更新历史未缴费电表读数记录中的用电量和金额
 * @param {Object} data
 * @returns
 */
export function updateAmountByContractId (data) {
  return request.post('/ooh-invest/electricMeterRecord/updateAmountByContractId', qs.stringify(data))
}
